import { atom, useAtom } from "jotai";

export enum AuthModalScreen {
  EnterEmail = 0,
  EnterPassword = 1,
  Register = 2,
  VerifyEmail = 8,
  ForgotPassword = 9,
  ResetForgotPassword = 10,
  OnboardingScreen = 11,
  VerifyTermsAndConditions = 12,
  /**
   * The onboarding questions after an account is created. Replaced the old
   * `OnboardingStep1`-`5` profile wizard (3-7), whose numbers are left unused.
   */
  SignUpOnboarding = 13,
}

export const authModalOpenAtom = atom(false);
export const viewIndexAtom = atom<AuthModalScreen>(AuthModalScreen.EnterEmail);
/**
 * A screen mid-request that must finish before it unmounts (a verify whose reply commits a
 * session, the sign-up hand-off). While set, the shell ignores Esc and backdrop clicks.
 */
export const authModalBusyAtom = atom(false);

export function useAuthModals() {
  const [authModal, setAuthModal] = useAtom(authModalOpenAtom);
  const [screenIndex, setScreenIndex] = useAtom(viewIndexAtom);
  const [isBusy, setBusy] = useAtom(authModalBusyAtom);

  const showModal = (screenIndex: AuthModalScreen) => {
    // console.log("show");
    setAuthModal(true);
    setScreenIndex(screenIndex);
  };

  const hideModal = () => {
    // console.log("hide");
    setAuthModal(false);
    setBusy(false);
  };

  return {
    showModal,
    hideModal,
    isAuthModalVisible: authModal,
    screenIndex,
    setScreenIndex,
    isBusy,
    setBusy,
  };
}
